module.exports = __webpack_public_path__ + "static/img/tab-ten-active.2c9cd925.png";